<template>
  <div id="app">
    <Layout/>
  </div>
</template>

<script>
import Layout from '_c/Layout'

export default {
  name: 'app',
  components: {
    Layout
  }
}
</script>
